/* blocks */
import PageHero from '@/cmp/organism/PageHero/PageHero'
import CustomerLogo from '@/cmp/organism/CustomerLogo/CustomerLogo'
import ValueOutcomes from '@/cmp/organism/ValueOutcomes/ValueOutcomes'
import ServicePicker from '../ContentTypes/components/ServicePicker/ServicePicker'
import ContentTypeFeatures from '@/cmp/organism/ContentTypeFeatures/ContentTypeFeatures'
import CaseStudies from '../ContentTypes/components/CaseStudies/CaseStudies'
import FAQNew from '@/cmp/organism/FAQNew/FAQNew'
import FooterCta from '@/cmp/organism/FooterCta/FooterCta'

/* utils */
import { DemandGenOverviewPageAttributes } from '@/utils/queries/overview-pages/demand_gen_overview_page'
import { AllCaseStudyPageAttributes } from '@/utils/queries/customer_case_study'

/* styles */
import styles from './_.module.css'

interface Props {
  data: DemandGenOverviewPageAttributes
  caseStudies: {
    attributes: AllCaseStudyPageAttributes
  }[]
}

function DemandGenOverview({ data, caseStudies }: Props): JSX.Element {
  return (
    <>
      <PageHero
        layout="left"
        class={styles.pageHero}
        primaryHeadline={data.hero.title}
        subText={data.hero.description}
        primaryCta={data.hero.primaryCta}
        image={data.hero.image?.data?.attributes}
      />

      {data.brandList.brands.data.length > 0 ? (
        <CustomerLogo
          title={data.brandList.title}
          brands={data.brandList.brands.data.map(i => ({
            ...i.attributes.logo.data.attributes,
            alternativeText: i.attributes.name
          }))}
        />
      ) : null}

      {data.goalList.length > 0 ? (
        <ValueOutcomes
          layout="descriptive"
          theme="dark"
          title={data.goalTitle}
          list={data.goalList.map(i => ({
            id: i.id,
            title: i.title ?? '',
            description: i.description ?? '',
            image: i.multimedia?.media?.data?.attributes
          }))}
        />
      ) : null}

      {data.services.length > 0 ? (
        <ServicePicker
          title={data.servicesTitle}
          description={data.servicesDescription}
          services={data.services}
        />
      ) : null}

      {data.contentTypeFeatureList.length > 0 ? (
        <ContentTypeFeatures
          title={data.contentTypeFeatureTitle}
          list={data.contentTypeFeatureList.map(i => ({
            id: i.id,
            link: i.link,
            bgColor: i.color,
            title: i.title ?? '',
            description: i.description ?? '',
            image: i.multimedia?.media?.data?.attributes,
            tag: i.additionalFields?.tag as string | null,
            color: i.additionalFields?.color as string | null
          }))}
        />
      ) : null}

      {caseStudies.length > 0 ? (
        <CaseStudies
          title={data.caseStudyTitle}
          data={caseStudies}
          mode="light"
        />
      ) : null}

      {data.faqs.length > 0 ? (
        <FAQNew title="Frequently asked questions" list={data.faqs} />
      ) : null}

      {data.footerCta ? (
        <FooterCta
          headline={data.footerCta.title}
          mode="full_width"
          primaryCta={data.footerCta.primaryCta}
          secondaryCta={data.footerCta.secondaryCta}
        />
      ) : null}
    </>
  )
}

export default DemandGenOverview
